import { VehicleType } from '../../enums/VehicleType';
import { Action } from '../../types/Action';

export const setYears = (years: number[]): Action => ({
  type: FilterInventoryActionType.SET_YEARS,
  payload: years,
});

export const setModels = (models: string[]): Action => ({
  type: FilterInventoryActionType.SET_MODELS,
  payload: models,
});

export const setTrims = (trims: string[]): Action => ({
  type: FilterInventoryActionType.SET_TRIMS,
  payload: trims,
});

export const setVehicleTypes = (vehicleTypes: VehicleType[]): Action => ({
  type: FilterInventoryActionType.SET_VEHICLE_TYPES,
  payload: vehicleTypes,
});

export const setBrands = (brands: string[]): Action => ({
  type: FilterInventoryActionType.SET_BRANDS,
  payload: brands,
});

export const setDaysOnLot = (ageDays: MinMaxFilter): Action => ({
  type: FilterInventoryActionType.SET_DAYS_ON_LOT,
  payload: ageDays,
});

export const setMileage = (mileage: MinMaxFilter): Action => ({
  type: FilterInventoryActionType.SET_MILEAGE,
  payload: mileage,
});

export const setPrice = (price: MinMaxFilter): Action => ({
  type: FilterInventoryActionType.SET_PRICE,
  payload: price,
});

export const setExteriorColor = (exteriorColor: string[]): Action => ({
  type: FilterInventoryActionType.SET_EXTERIOR_COLOR,
  payload: exteriorColor,
});

export const setInteriorColor = (interiorColor: string[]): Action => ({
  type: FilterInventoryActionType.SET_INTERIOR_COLOR,
  payload: interiorColor,
});

export const setSearch = (search: string): Action => ({
  type: FilterInventoryActionType.SET_SEARCH,
  payload: search,
});

export const resetFilters = (): Action => ({
  type: FilterInventoryActionType.FILTERS_RESET,
});

export enum FilterInventoryActionType {
  SET_YEARS = '[FILTERS] Set Years',
  SET_MODELS = '[FILTERS] Set Models',
  SET_TRIMS = '[FILTERS] Set Trims',
  SET_VEHICLE_TYPES = '[FILTERS] Set Vehicle Types',
  SET_BRANDS = '[FILTERS] Set Brands',
  SET_DAYS_ON_LOT = '[FILTERS] Set Days on Lot',
  SET_MILEAGE = '[FILTERS] Set Mileage',
  SET_PRICE = '[FILTERS] Set Price',
  SET_EXTERIOR_COLOR = '[FILTERS] Set Exterior Color',
  SET_INTERIOR_COLOR = '[FILTERS] Set Interior Color',
  SET_SEARCH = '[FILTERS] Set Search',
  FILTERS_RESET = '[FILTERS] Reset Filters',
}

export type FilterInventoryAction = ReturnType<
  | typeof setYears
  | typeof setModels
  | typeof setTrims
  | typeof setVehicleTypes
  | typeof setBrands
  | typeof setDaysOnLot
  | typeof setMileage
  | typeof setPrice
  | typeof setExteriorColor
  | typeof setInteriorColor
  | typeof setSearch
  | typeof resetFilters
>;

export type MinMaxFilter = {
  min: number;
  max: number;
};

export type SearchFilter = {
  current: string;
  previous: string;
};
